import userStorage from '@/shared/services/userStorage';

// Seed every defined column to false so that columns which are filtered out by their `enabled`
// check still get an explicit boolean. Without this they would be absent from the status object,
// and consumers that default an undefined value to visible would render a header without a cell.
const generateColumnStatus = (columnDefinitions, hideableColumns) => {
  const status = columnDefinitions.reduce((o, col) => {
    // eslint-disable-next-line no-param-reassign
    o[col.id] = false;
    return o;
  }, {});
  return hideableColumns.reduce((o, col) => {
    // eslint-disable-next-line no-param-reassign
    o[col.id] = !!col.selected;
    return o;
  }, status);
};

export const initHiddenColumnsState = (columnSelectionStorageKey, columnDefinitions, intl) => {
  const columnsFromStorage = userStorage.getItem(columnSelectionStorageKey);
  const initColumns = typeof columnsFromStorage === 'undefined' || columnsFromStorage === null;
  const hiddenColumns = columnsFromStorage || [];
  const hideableColumns = columnDefinitions
    .filter(f => {
      if (typeof f.enabled === 'undefined') return true;
      if (typeof f.enabled === 'function') return !!f.enabled();
      return !!f.enabled;
    })
    .map(({ id, message, visibleByDefault = true }) => ({
      id,
      label: intl.formatMessage(message),
      selected: !initColumns ? hiddenColumns.indexOf(id) === -1 : !!visibleByDefault,
    }));
  const columnStatus = generateColumnStatus(columnDefinitions, hideableColumns);
  return {
    hideableColumns,
    columnStatus,
  };
};

export const handleHiddenColumnsSelection = (
  items,
  hideableColumns,
  columnSelectionStorageKey,
  columnDefinitions = [],
) => {
  const hiddenColumns = items.filter(x => !x.selected).map(x => x.id);
  userStorage.setItem(columnSelectionStorageKey, hiddenColumns);

  const newHideableColumns = hideableColumns.map(x => ({
    ...x,
    selected: hiddenColumns.indexOf(x.id) === -1,
  }));
  const columnStatus = generateColumnStatus(columnDefinitions, newHideableColumns);
  return {
    hideableColumns: newHideableColumns,
    columnStatus,
  };
};

export const countVisibleColumns = (columnStatus, ...columnNames) => {
  if (!columnStatus || typeof columnStatus !== 'object') return 0;
  // eslint-disable-next-line no-param-reassign
  if (!columnNames || columnNames.length === 0) columnNames = Object.keys(columnStatus);

  return columnNames.flat().reduce((count, name) => {
    if (columnStatus[name]) return count + 1;
    return count;
  }, 0);
};
